<!--
Notifications screen
@author ab557z
-->

<template>
  <div id="contain" class="container">
    <Nav name="Notifications" :step="true" />
    <Spinner ref="spinner" />
    <main class="p-2">
      <div>
        <p @click="hideNotif" class="notifActionText2">Mark all as read</p>
      </div>
      <div style="margin-top:64px;margin-left:24px;margin-right:24px;" v-if="this.notifications[1]!=false">
        <NotifItem v-for="(notification,index) in notifications"
                  :key="index" :paramKey="index" :title="notification.title" :body="notification.body"
                  :time="notification.time" :icon="notification.icon" :link="notification.link" :unread="unread"
        />
      </div>
      <div v-if="this.notifications.length<1">
           <h5 style="color:#074C4C;text-align:center">Currently, you have no notifications.</h5>
      </div>
    </main>
    <div id="pusher"></div>
    <Footer active="notifications"/>
  </div>
</template>

<script>
import * as lst from '@/components/localStorage.js'
import axios from 'axios'
import NotifItem from '@/components/NewNotificationItem.vue'
import Footer from '@/components/FooterMenu.vue'

export default {
  name: 'Notifications',
  components: {
    NotifItem,
    Footer
  },
  data () {
    return {
      notifications: {}
    }
  },

  mounted () {
    this.getNotif()
  },
  methods: {
    getNotif () {
      this.$refs.spinner.spin()
      axios.get('/timetable/notifications', { withCredentials: true })
        .then(response => {
          this.fetchedNotifications = response.data.splice(1)
          this.unread = response.data[0]
          // if ($cookies.get('showNotifications') === 'true') {
          this.notifications = this.fetchedNotifications
        //  } else {
          //   if (this.unread > 0) {
          //    this.notifications = this.fetchedNotifications.slice(0, this.unread)
          // a  }
          // }
        })
        .finally(() => {
          this.$refs.spinner.stop()
          if (process.env.VUE_APP_MODE === 'hybrid') {
            window.FirebasePlugin.setBadgeNumber(0)
          }
        })
    },
    showNotif () {
      lst.setValue('showNotifications', true)
      this.getNotif()
    },
    hideNotif () {
      axios.post('/timetable/notifications/unread', { withCredentials: true })
        .then(() => {
          lst.setValue('unreadNotifications', 0)

          for (let i = 0; i < this.unread; i++) {
            document.getElementById('nibg' + i).removeAttribute('style', 'background-color:rgba(0, 56, 101, 0.1);')
          }
          this.unread = 0
        })
    }
  }
}
</script>
<style>

.notifActionText2 {
  float:right;
  margin-right:24px;
  margin-top:16px;
  font-weight:bold;
  color:#003865;
}

</style>
